import { createUrl, toBlob } from "components/Environment/helpers";
import { Download } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import TileTitle from "ds/components/Tile/Title";
import TileWrapper from "ds/components/Tile/Wrapper";
import { Maybe } from "types/generated";
import { downloadFileFromURL } from "utils/file";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

type EnvironmentPreviewFileProps = {
  relativePath: string;
  value: Maybe<string>;
  writeOnly: boolean;
};

const EnvironmentPreviewFile = ({
  relativePath,
  value,
  writeOnly,
}: EnvironmentPreviewFileProps) => {
  const { reportError } = useTypedContext(FlashContext);

  const handleOnClick = () => {
    if (!value) {
      return;
    }

    const blob = toBlob(value);

    if (!blob) {
      return reportError({ message: "Something went wrong. Please try again later." });
    }

    downloadFileFromURL(createUrl(blob), relativePath);
  };

  return (
    <TileWrapper>
      <Box gap="x-large" justify="between" fullWidth>
        <TileTitle>{relativePath}</TileTitle>
        {!writeOnly && value && (
          <ButtonIcon icon={Download} onPress={handleOnClick} variant="ghost">
            Download
          </ButtonIcon>
        )}
      </Box>
    </TileWrapper>
  );
};

export default EnvironmentPreviewFile;
